import { render, staticRenderFns } from "./settings-team-number-voice.vue?vue&type=template&id=f4fd9702&scoped=true&"
import script from "./settings-team-number-voice.vue?vue&type=script&lang=js&"
export * from "./settings-team-number-voice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fd9702",
  null
  
)

export default component.exports